import data from "./inspeccionSchema";

export default {
  state: {
    documentacion: null,
    OrdenYAseo: null,
    carroceria: null,
    cabina: null,
    motor: null,
    herramientas: null,
    kitAmbiental: null,
  },
  mutations: {
    initInspeccionVehiculo(state) {
      state.documentacion = data.documentacion;
      state.OrdenYAseo = data.OrdenYAseo;
      state.carroceria = data.carroceria;
      state.cabina = data.cabina;
      state.motor = data.motor;
      state.herramientas = data.herramientas;
      state.kitAmbiental = data.kitAmbiental;
    },
  },
  actions: {
    initInspeccionVehiculo({ commit }) {
      commit("initInspeccionVehiculo");
    },
    async getVehiculosInspeccion({ rootGetters }, sucursalId) {
      const url = sucursalId
        ? `SstInspeccion/GetVehiculosInspeccion/${sucursalId}`
        : `SstInspeccion/GetVehiculosInspeccion`;
      try {
        const response = await rootGetters.fetchGet({ path: url });
        if (response.ok) {
          const allData = await response.json();
          console.log(allData.data);

          return allData.data;
        } else {
          console.error("Error en la respuesta del servidor", response);
          return [];
        }
      } catch (error) {
        console.error("Error en getSucursales:", error);
        return [];
      }
    },

    async getSucursalPersona({ rootGetters }, personaId) {
      try {
        const response = await rootGetters.fetchGet({
          path: `SstInspeccion/GetSucursalPersona/${personaId}`,
        });
        if (response.ok) {
          const allData = await response.json();
          console.log(allData.data);

          return allData.data;
        } else {
          console.error("Error en la respuesta del servidor", response);
          return [];
        }
      } catch (error) {
        console.error("Error en getSucursales:", error);
        return [];
      }
    },
    async getListInspeccionesByVehiculoId({ rootGetters }, vehiculoId) {
      try {
        const response = await rootGetters.fetchGet({
          path: `SstInspeccion/GetListInspeccionesByVehiculoId/${vehiculoId}`,
        });
        if (response.ok) {
          const allData = await response.json();
          console.log(allData.data);

          return allData.data;
        } else {
          console.error("Error en la respuesta del servidor", response);
          return [];
        }
      } catch (error) {
        console.error("Error en getSucursales:", error);
        return [];
      }
    },
  },
  getters: {},
};
